<template>
    <Card>
        <div class="ql-editor" v-html="content.lesson_translation.description"></div>
    </Card>
</template>

<script>

import Card from '../../../../argon/components/Cards/Card';

export default {
    name: 'OptionsDescription',

    components: {
        Card,
    },

    props: {
        content: {
            type: Object,
        },
    },
};
</script>

<style>

</style>
